import type { JSX } from 'react'

export const SaveIcon = (): JSX.Element => (
  <use href='#saveIcon' height='100%' width='100%' />
)
